// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"arrow-link-back_arrowLink__rBdA_","left":"arrow-link-back_left__MtTjp","right":"arrow-link-back_right__xg9kv"};